import { ComponentPropsWithRef } from "react";

export const PreviousIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.08318 7.57384C7.76519 7.76897 7.76519 8.23103 8.08318 8.42616L19.6642 15.5327C19.9974 15.7371 20.4257 15.4974 20.4257 15.1065V0.893451C20.4257 0.502575 19.9974 0.262855 19.6642 0.467289L8.08318 7.57384Z"
      fill="currentColor"
    />
    <rect
      width="2.5"
      height="13.037"
      rx="0.4"
      transform="matrix(-1 0 0 1 2.50003 1.48164)"
      fill="currentColor"
    />
  </svg>
);
